/**
 * Created by iamso on 25.12.2019.
 */

cleverapps.GameSaver = {
    init: function () {
        if (this.gamesData === undefined) {
            this.gamesData = cleverapps.dataLoader.load(DataLoader.TYPES.GAME_SAVE) || {};
        }
    },

    getStoreSlot: function (episodeNo, levelNo) {
        episodeNo = episodeNo || 0;
        levelNo = levelNo || 0;

        return `${levelNo}x${episodeNo}`;
    },

    load: function (episodeNo, levelNo) {
        this.init();

        const slot = this.getStoreSlot(episodeNo, levelNo);
        const saveData = this.gamesData[slot];
        return saveData && JSON.parse(saveData);
    },

    save: function (gameData, episodeNo, levelNo) {
        this.init();

        const slot = this.getStoreSlot(episodeNo, levelNo);
        delete this.gamesData[slot];

        const slots = Object.keys(this.gamesData);
        if (slots.length >= 10) {
            delete this.gamesData[slots[0]];
        }

        this.gamesData[slot] = JSON.stringify(gameData);
        cleverapps.dataLoader.save(DataLoader.TYPES.GAME_SAVE, this.gamesData);
    },

    remove: function (episodeNo, levelNo) {
        this.init();

        const slot = this.getStoreSlot(episodeNo, levelNo);
        delete this.gamesData[slot];
        cleverapps.dataLoader.save(DataLoader.TYPES.GAME_SAVE, this.gamesData);
    },

    reset: function () {
        this.gamesData = {};
        cleverapps.dataLoader.save(DataLoader.TYPES.GAME_SAVE, this.gamesData);
    }
};